<template>
  <div>
    <v-row align="center">
      <v-col cols="12" md="auto" class="text-start">
        <span class="textLight--text font-weight-medium text-h5">
          {{ $t("quiz.quizzes") }}
        </span>
      </v-col>

      <v-spacer />

      <v-col cols="12" md="auto">
        <QuizCreateButton v-if="havePermissionCreateQuiz" />
      </v-col>

      <v-col cols="12" md="3">
        <v-select
          v-model="quizType"
          hide-details
          :items="quizTypes"
          item-value="value"
          solo
          flat
          class="rounded-lg"
        >
          <template v-slot:item="{ item }">
            {{ item.text }}
          </template>
        </v-select>
      </v-col>

      <v-col cols="12" md="3">
        <v-text-field
          v-model="search"
          hide-details
          prepend-inner-icon="mdi-magnify"
          color="textLight"
          :placeholder="$t('course.search')"
          solo
          flat
          clearable
          class="shrink rounded-lg"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <AvailableQuizList
          :data="quizzesData"
          :loading="loading"
          @quizzesReRender="refetch()"
        />
      </v-col>

      <v-col cols="12" v-if="quizzesData && quizzesData.length">
        <Pagination :length="totalPages" @onPageSelect="onPagination" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { hasPermission } from "@/app/user-module/helpers/authHelper";

import AvailableQuizList from "./AvailableQuizList";
import Pagination from "../../core-module/components/Pagination.vue";
import QuizCreateButton from "@/app/quiz-module/components/QuizCreateButton";

export default {
  name: "AvailableQuizzes",
  components: {
    QuizCreateButton,
    AvailableQuizList,
    Pagination,
  },
  data() {
    return {
      search: null,
      quizzesData: [],
      totalCount: null,
      quizType: "APPROVED",
      quizTypes: [
        {
          text: "Available",
          value: "APPROVED",
        },
        {
          text: "Approval Pending",
          value: "PENDING",
        },
        {
          text: "Enabled",
          value: "ENABLED",
        },
        {
          text: "Disabled",
          value: "DISABLED",
        },
        {
          text: "Rejected",
          value: "REJECTED",
        },
        {
          text: "Preparing",
          value: "PREPARING",
        },
      ],
      loading: true,
      pageInput: this.defaultPageInput(),
      debounceSearch: null,
      totalPages: 0,
    };
  },
  created() {
    this.$apollo.queries.getQuizContents.refetch();
  },
  apollo: {
    getQuizContents() {
      return {
        query: require("../../quiz-module/api/query/getQuizContents.gql"),
        variables: {
          pageInput: this.pageInput,
          filterInput: {
            approvalStatus: this.fetchApprovalStatus(),
            isActive: this.fetchIsActive(),
          },
        },
        result({ data, loading }) {
          if (data?.getQuizContents?.quizContents) {
            this.quizzesData = data.getQuizContents.quizContents;
            this.totalCount = data.getQuizContents.totalCount;

            let pagesVal = this.totalCount / this.defaultPageInput().limit;
            this.totalPages = this.checkNumberIsFloat(pagesVal)
              ? Math.ceil(pagesVal)
              : pagesVal;
          } else {
            this.quizzesData = [];
            this.totalCount = 0;
            this.totalPages = 0;
          }

          this.loading = loading;
        },
      };
    },
  },
  watch: {
    search() {
      clearTimeout(this.debounceSearch);

      this.debounceSearch = setTimeout(() => {
        this.apiSearch();
      }, 500);
    },
    quizType() {
      this.pageInput = this.defaultPageInput();
      this.refetch();
    },
  },
  methods: {
    checkNumberIsFloat(value) {
      return Number(value) === value && value % 1 !== 0;
    },
    apiSearch() {
      const searchText = this.search?.trim() ?? "";

      if (searchText.length > 0) {
        this.pageInput = this.defaultPageInput();
        this.search = searchText;
        this.refetch();
      } else if (searchText.length === 0) {
        this.search = null;
        this.pageInput = this.defaultPageInput();
        this.refetch();
      }
    },
    havePermissionCreateQuiz() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["CREATE_QUIZ"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
    fetchIsActive() {
      if (this.quizType === "ENABLED") {
        return true;
      } else if (this.quizType === "DISABLED") {
        return false;
      }
    },
    fetchApprovalStatus() {
      if (
        this.quizType === "APPROVED" ||
        this.quizType === "PENDING" ||
        this.quizType === "REJECTED" ||
        this.quizType === "PREPARING"
      ) {
        return this.quizType;
      } else return null;
    },
    onPagination(val) {
      if (val > 0) {
        this.pageInput.skip = this.pageInput.limit * (val - 1);
        this.refetch();
      }
    },
    async refetch() {
      this.loading = true;
      this.quizzesData = [];
      this.totalCount = 0;
      this.totalPages = 0;

      this.$apollo.queries.getQuizContents.refetch({
        pageInput: this.pageInput,
        filterInput: {
          search: this.search ? this.search : null,
          approvalStatus: this.fetchApprovalStatus(),
          isActive: this.fetchIsActive(),
        },
      });
    },
  },
};
</script>
